import { all, call } from 'redux-saga/effects';
import { onAddRatingStart } from './addRatingSaga';
import { onAddSingleDefinitionStart } from './addSingleDefinitionSaga';
import { onAddSingleTraitStart } from './addSingleTraitSaga';
import { onAddTraitGroupStart } from './addTraitSaga';
import { onDeleteRatingStart } from './deleteRatingSaga';
import { onDeleteSingleDefinitionStart } from './deleteSingleDefinitionSaga';
import { onDeleteSingleRatingStart } from './deleteSingleSubRaiting';
import { onDeleteSingleTraitStart } from './deleteSingleTraitSaga';
import { onEditRatingNameStart } from './editRatingNameSaga';
import { onEditSingleDefinitionStart } from './editSingleDefinitionSaga';
import { onEditRateRemarkStart } from './editSingleRateDefinition';
import { onEditSingleTraitStart } from './editSingleTraitSaga';
import { onFetchAllTraitsStart } from './fetchAllTraitsSaga';
import { onFetchAllRatingsStart } from './fetchRatingSaga';

export default function* EarlyYearsGradingSaga() {
  yield all([
    call(onFetchAllTraitsStart),
    call(onAddSingleTraitStart),
    call(onAddTraitGroupStart),
    call(onEditSingleTraitStart),
    call(onDeleteSingleTraitStart),
    call(onAddSingleDefinitionStart),
    call(onEditSingleDefinitionStart),
    call(onDeleteSingleDefinitionStart),
    call(onAddRatingStart),
    call(onFetchAllRatingsStart),
    call(onEditRatingNameStart),
    call(onDeleteRatingStart),
    call(onDeleteSingleRatingStart),
    call(onEditRateRemarkStart),
  ]);
}
